import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CommonApi from "../../../api/common.api";
import PopupApi from "../../../api/popup.api";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import ImgInput from "../../../component/atoms/input/imgInput";
import MainInput from "../../../component/atoms/input/mainInput";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import GoBack from "../../../component/molecules/goBack";
import ImgPreview from "../../../component/molecules/imgPreview";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { isNull } from "../../../util/check";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import { imgUrl } from "../../../constants/url";

const PopupEdit = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  const [popupInfo, setPopupInfo] = useState({
    title: "",
  });

  const [pcImageList, setPcImageList] = useState([]);
  const [moImageList, setMoImageList] = useState([]);

  const getPopupInfo = async () => {
    try {
      let response = (await PopupApi.getById(id)).data.data.content;

      if (response.pcImageList) {
        const pcImageList = response.pcImageList?.map((item) => {
          return {
            ...item,
            fileUrl: imgUrl + item.imageServerFileName,
          };
        });

        setPcImageList(pcImageList);
      }

      if (response.moImageList) {
        const moImageList = response.moImageList?.map((item) => {
          return {
            ...item,
            fileUrl: imgUrl + item.imageServerFileName,
          };
        });

        setMoImageList(moImageList);
      }

      setPopupInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    getPopupInfo();
  }, []);

  //이미지 추가, 삭제
  const inputFile = (type, e) => {
    const file = e.target.files[0];

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (value) => {
      if (type === "pc") {
        const copyPcImgList = [...pcImageList];

        copyPcImgList.push({
          file: file,
          fileUrl: value.target.result,
        });

        setPcImageList(copyPcImgList);
      }

      if (type === "mobile") {
        const copyMoImgList = [...moImageList];

        copyMoImgList.push({
          file: file,
          fileUrl: value.target.result,
        });

        setMoImageList(copyMoImgList);
      }
    };
    e.target.value = "";
  };

  const deleteFile = (type, index, id) => {
    if (type === "pc") {
      const copyPcImgList = [...pcImageList];
      copyPcImgList.splice(index, 1);
      setPcImageList(copyPcImgList);
    }

    if (type === "mobile") {
      const copyMoImgList = [...moImageList];
      copyMoImgList.splice(index, 1);
      setMoImageList(copyMoImgList);
    }

    if (id) {
      setDelFileIdList([...delFileIdList, id]);
    }
  };

  //저장하기
  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveBtnHandler = () => {
    if (
      isNull(popupInfo.title.trim()) ||
      pcImageList.length === 0 ||
      moImageList.length === 0
    ) {
      return toast("필수사항을 모두 입력해주세요.");
    }

    setSaveModalOpen(true);
  };

  const saveFunc = async () => {
    try {
      const pcResult = await Promise.all(
        pcImageList
          .filter((item) => item.file) // file이 있는 항목만 남김
          .map(async (item) => {
            const response = await fileUpload(item.file);
            return response;
          })
      );

      const moResult = await Promise.all(
        moImageList
          .filter((item) => item.file) // file이 있는 항목만 남김
          .map(async (item) => {
            const response = await fileUpload(item.file);
            return response;
          })
      );

      const data = {
        deletePopupImageIdList: delFileIdList,
        title: popupInfo.title,
        pcImageList: pcResult,
        moImageList: moResult,
      };

      await PopupApi.update(id, data);
      setSaveModalOpen(false);
      navigate(-1);
      toast(toastMsg.create);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 파일 업로드
  const fileUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("path", "popup");
      formData.append("file", file);

      const response = (await CommonApi.fileUpload(formData)).data.data;

      return {
        imageOriginFileName: file.name,
        imageServerFileName: response.serverFileName,
      };
    } catch (error) {
      errorHandler(error);
    }
  };

  const [delFileIdList, setDelFileIdList] = useState([]);

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>추가하기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>팝업명*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "338px",
                  }}
                  type={"text"}
                  placeholder={"팝업명 을(를) 입력해주세요"}
                  value={popupInfo.title}
                  onChange={(e) =>
                    setPopupInfo({ ...popupInfo, title: e.target.value })
                  }
                />
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>
                  PC 이미지/최대 5장*
                  <br />
                  (권장사이즈 450*388)
                </DetailFormTitle>
                {pcImageList.length > 0 ? (
                  <>
                    {pcImageList.map((item, index) => {
                      return (
                        <ImgPreview
                          key={"pc" + index}
                          fileUrl={item.fileUrl}
                          onClick={() => {
                            deleteFile("pc", index, item.id);
                          }}
                        />
                      );
                    })}
                  </>
                ) : null}
                {pcImageList.length < 5 ? (
                  <ImgInput
                    id={"pc"}
                    accept={"image/*"}
                    onChange={(e) => {
                      inputFile("pc", e);
                    }}
                  />
                ) : null}
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>
                  모바일 이미지/최대 5장*
                  <br />
                  (권장사이즈 335*288)
                </DetailFormTitle>
                {moImageList.length > 0 ? (
                  <>
                    {moImageList.map((item, index) => {
                      return (
                        <ImgPreview
                          key={"mo" + index}
                          fileUrl={item.fileUrl}
                          onClick={() => {
                            deleteFile("mobile", index, item.id);
                          }}
                        />
                      );
                    })}
                  </>
                ) : null}
                {moImageList.length < 5 ? (
                  <ImgInput
                    id={"mobile"}
                    accept={"image/*"}
                    onChange={(e) => {
                      inputFile("mobile", e);
                    }}
                  />
                ) : null}
              </DetailPageForm>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 30,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "30px",
                }}
              >
                <SaveBtn
                  onClick={() => {
                    saveBtnHandler();
                  }}
                />
              </div>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          setModalOpen={setSaveModalOpen}
          onClick={saveFunc}
        />
      ) : null}
    </>
  );
};

export default PopupEdit;
